import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Milestone2PaymentBatchStatus } from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { MsaipPaymentBatchMilestone2 } from '../../../models/msaip-payment-batch-milestone2.model';
import { MsaipPaymentScheduleActivitiesM2 } from '../../../models/msaip-payment-schedule-activities-m2.model';
import { PaymentBatchStatusM2 } from '../../../models/payment-batch-status-m2.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { MsaipPaymentScheduleService } from '../../services/msaip-payment-schedule.service';

@Component({
  selector: 'app-new-msaip-payment-batch-milestone2',
  templateUrl: './new-msaip-payment-batch-milestone2.component.html',
  styleUrls: ['./new-msaip-payment-batch-milestone2.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class NewMsaipPaymentBatchMilestone2Component implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  engagementList: MsaipPaymentScheduleActivitiesM2[] = [];
  paymentBatchStatus: PaymentBatchStatusM2[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  paymentBatchForm!: FormGroup;
  createPaymentBatch!: MsaipPaymentBatchMilestone2;
  selectedEngagements: MsaipPaymentScheduleActivitiesM2[] = [];
  clonedEngs: Record<number, MsaipPaymentScheduleActivitiesM2> = {};
  editing = false;
  editingNav = false;
  isSpin = false;
  showForm = true;
  disableSubmit = false;
  firstEditInitEng!: MsaipPaymentScheduleActivitiesM2;
  editRowsCtr = 0;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';

  constructor(
    private pmService: MsaipPaymentScheduleService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    public settings: SettingsService,
    public router: Router
  ) {}

  ngOnInit() {
    this.loading = true;
    this.editing = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.engcols = [
      { field: 'incentiveId', header: 'Activity ID' },
      { field: 'engagementName', header: 'Activity Name' },
      { field: 'engagementSubType', header: 'Sub Type' },
      { field: 'program', header: 'Program' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'tier', header: 'Milestone 2 Tier' },
      { field: 'fundingAmount', header: 'Funding Amount' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'paymentProfileStatus', header: 'ProfileStatus' },

      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'sspaStatus', header: 'SSPA Status' },

      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'contactName', header: 'Contact Name' },
      { field: 'contactEmail', header: 'Contact Email' },
      { field: 'emailLanguage', header: 'Email Language' },
      { field: 'accountCode', header: 'Account Code' },
      {
        field: 'internalOrderOrCostCenter',
        header: 'Internal Code or Cost Center'
      },
      { field: 'currency', header: 'Currency' },
      { field: 'amount', header: 'Amount' },
      { field: 'netAmount', header: 'Net Amount' },
      { field: 'taxAmount', header: 'Tax Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.paymentBatchForm = this.formBuilder.group({
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEngs: [''],
      tier: [''],
      fundingAmount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      amount: [''],
      netAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionID: ['']
    });

    this.getEngagementDetials();
    this.getPaymentBatchStatus();
  }
  getEngagementDetials() {
    this.pmService
      .GetMsaipMilestone2PaymentScheduleActivities()
      .subscribe(engList => {
        this.engagementList = engList;
        if (this.engagementList != null) {
          this.totalRecords = this.engagementList.length;
        } else {
          this.totalRecords = 0;
        }

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }

        this.loading = false;
      });
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.filterGlobal('', 'contains');
      this.dt.sortField = 'incentiveId';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }

    if (this.engagementList === null || this.engagementList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.totalRecords = this.engagementList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }

  getPaymentBatchStatus() {
    this.pmService.getMilestone2PaymentBatchStatus().subscribe(engList => {
      this.paymentBatchStatus = engList;
    });
  }

  onSubmit() {
    this.loading = true;
    const datePipe = new DatePipe('en-US');

    this.createPaymentBatch = {
      createdByUserAlias: this.settings.AliasName || '',
      paymentBatchScheduleDate:
        datePipe.transform(
          this.paymentBatchForm.controls['paymentBatchScheduleDate'].value,
          'MM/dd/yyyy'
        ) || '',
      anticipatedPaymentDate:
        datePipe.transform(
          this.paymentBatchForm.controls['anticipatedPaymentDate'].value,
          'MM/dd/yyyy'
        ) || '',
      actualPaymentCentralDate:
        datePipe.transform(
          this.paymentBatchForm.controls['actualPaymentCentralDate'].value,
          'MM/dd/yyyy'
        ) || '',
      paymentBatchStatusId:
        this.paymentBatchForm.controls['paymentBatchStatus'].value.id,
      PaymentBatchDetails: []
    };

    if (
      this.selectedEngagements.length !== 0 ||
      this.selectedEngagements.length !== undefined
    ) {
      for (const item of this.selectedEngagements) {
        this.createPaymentBatch.PaymentBatchDetails?.push({
          incentiveId: item.incentiveId,
          engagementName: item.engagementName,
          engagementSubType: item.engagementSubType,
          tier: item.tier,
          fundingAmount: item.fundingAmount,
          partnerId: item.partnerId,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          amount: item.amount,
          netAmount: item.netAmount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoiceDate: item.msInvoicePaidDate,
          paymentCentralTransactionID: item.paymentCentralTransactionID,
          payoutMatric: item.payoutMetric,
          engagementSubID: item.engagementSubID
        });
        const mn = this.engagementList.find(
          it => it.incentiveId === item.incentiveId
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.incentiveId);
        }
      }
    }
    if (
      this.selectedEngagements.length === 0 &&
      this.createPaymentBatch.paymentBatchStatusId !==
        Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Activity from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    this.createPaymentBatch.editids = this.selectedEngagements
      .filter(e => e.edited === true)
      .map(e => e.incentiveId)
      .toString();
    this.pmService
      .createMsaipPaymentBatchMilestone2(this.createPaymentBatch)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.msgs = [];
            this.msgs.push({
              severity: 'success',
              detail: 'Payment Batch Created Successfully'
            });
            this.selectedEngagements = [];
            this.paymentBatchForm.reset();
            setTimeout(() => {
              this.router.navigate(['msaip-milestone2-payment-schedule']);
            }, 2000);
          } else if (this.apires.success === false) {
            this.loading = false;
            this.msgs = [];
            this.msgs.push({
              severity: 'error',
              detail: this.apires.errorMessages?.[0]
            });
          }
          this.showForm = false;
        },
        error => {
          this.loading = false;
          this.msgs = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgs.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Creating Payment Batch'
            });
          }
          this.showForm = true;
        }
      );
  }

  onRowEditInit(eng: MsaipPaymentScheduleActivitiesM2) {
    this.clonedEngs[eng.incentiveId || -1] = { ...eng };
    this.disableSubmit = true;
    if (this.editRowsCtr === 0) {
      this.editing = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
  }

  selectRow(e, l) {
    const engagement = this.engagementList.find(
      item => item.incentiveId === l.incentiveId
    );

    if (engagement) {
      engagement.editCheckBox = !engagement.editCheckBox;
    }
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }
  cancelSearchNav() {
    this.router.navigate(['msaip-milestone2-payment-schedule']);
  }

  onRowEditSave(eng: MsaipPaymentScheduleActivitiesM2) {
    if (eng.amount !== null) {
      delete this.clonedEngs[eng.incentiveId || -1];
      this.disableSubmit = false;
      eng.edited = true;
      eng.partnerId = this.firstEditInitEng.partnerId;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.netAmount = this.firstEditInitEng.netAmount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionID =
        this.firstEditInitEng.paymentCentralTransactionID;
    }
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }

  onRowEditCancel(eng: MsaipPaymentScheduleActivitiesM2, index: number) {
    this.engagementList[index] = this.clonedEngs[eng.incentiveId || -1];
    delete this.clonedEngs[eng.incentiveId || -1];
    const idx = this.selectedEngagements.findIndex(
      e => e.incentiveId === eng.incentiveId
    );
    this.selectedEngagements.splice(idx, 1);
    this.engagementList[index].editCheckBox = false;
    this.disableSubmit = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }
}
